import React from 'react'

interface StarCloudIconProps {
  size?: number
  selected?: boolean
}

const CreativeOSAIIcon: React.FC<StarCloudIconProps> = ({ size = 27, selected = false }) => {
  const fillColor = selected ? '#673BEC' : 'black'
  const fillOpacity = 0.4

  return (
    <svg width={size} height={size} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7051 10.5182C23.1921 10.9708 22.5212 11.2391 21.7995 11.2391C20.5628 11.2391 19.4591 10.4479 19.0664 9.26964L18.8016 8.4755L18.0075 8.21078C16.8341 7.81964 16.0381 6.72084 16.0381 5.47907C16.0381 4.5789 16.4564 3.75385 17.1335 3.21905C16.6319 3.04154 16.1145 2.9033 15.5855 2.808C15.5526 2.79933 15.5192 2.79211 15.4852 2.78642C9.55861 1.79805 3.96514 6.30539 3.80035 12.5139C3.7856 13.0693 3.81867 13.5507 3.88283 14.0436C4.21243 16.5757 5.48203 18.8128 7.32651 20.3914L9.55619 22.1034H18.2104C18.4352 21.9298 18.6629 21.7587 18.8907 21.5873C19.8549 20.8623 20.8229 20.1345 21.6014 19.2075C23.1043 17.4318 23.9581 15.2152 23.9581 12.7309C23.9581 11.9707 23.8704 11.2301 23.7051 10.5182Z"
        fill={fillColor}
        fillOpacity={fillOpacity}
      />
      <path
        d="M9.79972 12.254C9.79972 10.27 11.4157 8.65401 13.3997 8.65401C13.9962 8.65401 14.4797 8.17048 14.4797 7.57401C14.4797 6.97754 13.9962 6.49401 13.3997 6.49401C10.2228 6.49401 7.63972 9.07706 7.63972 12.254C7.63972 12.8505 8.12324 13.334 8.71972 13.334C9.31618 13.334 9.79972 12.8505 9.79972 12.254Z"
        fill={'white'}
      />
      <path
        d="M17.8294 12.718L16.4672 12.2644L16.0121 10.9007C15.8652 10.4601 15.1351 10.4601 14.9883 10.9007L14.5332 12.2644L13.171 12.718C12.9507 12.7914 12.8009 12.9973 12.8009 13.2306C12.8009 13.4639 12.9507 13.6698 13.171 13.7433L14.5332 14.1969L14.9883 15.5605C15.0617 15.7808 15.2676 15.9292 15.4995 15.9292C15.7313 15.9292 15.9387 15.7794 16.0107 15.5605L16.4657 14.1969L17.828 13.7433C18.0483 13.6698 18.198 13.4639 18.198 13.2306C18.198 12.9973 18.0497 12.7914 17.8294 12.718Z"
        fill={fillColor}
      />
      <path
        d="M4.87822 4.09094C5.47467 4.09094 5.95822 3.60739 5.95822 3.01094C5.95822 2.41449 5.47467 1.93094 4.87822 1.93094C4.28177 1.93094 3.79822 2.41449 3.79822 3.01094C3.79822 3.60739 4.28177 4.09094 4.87822 4.09094Z"
        fill={fillColor}
      />
      <path
        d="M24.907 4.79654L23.0882 4.1903L22.482 2.37158C22.2847 1.78406 21.3127 1.78406 21.1154 2.37158L20.5092 4.1903L18.6905 4.79654C18.3967 4.89446 18.198 5.1695 18.198 5.4791C18.198 5.7887 18.3967 6.06374 18.6905 6.16166L20.5092 6.7679L21.1154 8.58662C21.2134 8.88038 21.4898 9.0791 21.7994 9.0791C22.109 9.0791 22.3841 8.88038 22.4834 8.58662L23.0897 6.7679L24.9084 6.16166C25.2022 6.06374 25.4009 5.7887 25.4009 5.4791C25.4009 5.1695 25.2007 4.89446 24.907 4.79654Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.31174 20.9218C7.50957 20.7455 7.76527 20.648 8.03022 20.648H19.7245C19.9893 20.648 20.2447 20.7454 20.4424 20.9213L21.7658 22.0992C21.8918 22.2113 21.9897 22.3512 22.0518 22.5081C22.5204 23.69 21.6483 24.9709 20.3782 24.9709H7.3779C6.1078 24.9709 5.2358 23.69 5.70429 22.5081C5.76632 22.3515 5.86411 22.2116 5.98982 22.0995L7.31174 20.9218Z"
        fill={fillColor}
      />
    </svg>
  )
}

export default CreativeOSAIIcon
